import { styled, Text, mq } from '@thg-commerce/gravity-theme'
import { DrawFocus } from '@thg-commerce/gravity-elements'
import { TabBorderStyle } from './Tabs'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TabList = styled.div`
  display: flex;
`

export const Tab = styled.button<{
  borderStyle: TabBorderStyle
}>`
  ${Text('bodyText', 'default')}
  color: ${(props) => props.theme.colors.palette.greys.darker};
  border: 1px solid transparent;
  width: 115px;
  height: 48px;
  padding-bottom: 2px;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 130px;
  }

  ${(props) =>
    props.borderStyle === 'MultiTab' &&
    `border-bottom: 1px solid ${props.theme.colors.palette.brand.lightest}`};

  &:hover,
  &:focus {
    background-color: ${(props) => props.theme.colors.palette.brand.lightest};
  }

  &:focus {
    border: 1px solid ${(props) => props.theme.colors.palette.brand.base};
    outline: none;
  }

  &[aria-selected='true'] {
    font-weight: 700;
    color: ${(props) => props.theme.colors.palette.brand.base};
    border-bottom: 3px solid ${(props) => props.theme.colors.palette.brand.base};
    padding-bottom: 0px;
  }
`

export const TabPanel = styled.div`
  ${DrawFocus()};
  min-height: 400px;
  width: 100%;
`
